var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1e1e1e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m125.25 841.23h180.5c20.75 0 41 5.5 58.75 16.5l374 229.5c4 2.5 8.5 3.75 13 3.75 4.25 0 8.5-1.25 12.25-3.25 8-4.5 12.75-12.75 12.75-21.75v-932c0-9-4.75-17.25-12.75-21.75-7.75-4.5-17.5-4.25-25.25 0.5l-374 229.5c-17.75 11-38 16.5-58.75 16.5h-180.5c-41.5 0-75.25 33.75-75.25 75.25v332c0 41.5 33.75 75.25 75.25 75.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m907.15 729.92c4.8594 4.8086 11.23 7.2266 17.578 7.2266 6.4453 0 12.891-2.4648 17.773-7.4219 34.547-34.91 53.59-80.98 53.59-129.73 0-48.926-19.066-94.922-53.688-129.54-9.7656-9.7656-25.586-9.7656-35.352 0-9.7656 9.7656-9.7656 25.586 0 35.352 25.172 25.172 39.039 58.617 39.039 94.191 0 35.496-13.891 69.066-39.137 94.578-9.7148 9.8164-9.6211 25.633 0.19531 35.352z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1015.7 838.46c4.8828 4.9062 11.305 7.3711 17.723 7.3711 6.3711 0 12.746-2.418 17.629-7.2773 63.793-63.453 98.926-148.19 98.926-238.57 0-90.062-35.109-174.75-98.879-238.53-9.7656-9.7656-25.586-9.7656-35.352 0s-9.7656 25.586 0 35.352c54.32 54.32 84.227 126.46 84.227 203.17 0 76.977-29.906 149.12-84.18 203.12-9.7891 9.7422-9.8398 25.562-0.097656 35.352z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.9df204b3881a46321e74358e036f8b4d.svg";
export { ForwardRef as ReactComponent };